import React, { useEffect, useRef } from "react";
import Card from '../pageInside/Card'
import { Row } from 'react-bootstrap';
import { isAuthenticated} from "../auth";
import ButtonPagination from "./ButtonPagination";
import { getElakayLanguageContext } from "./dataElakay";
import PaginationInfo from "../pageInside/paginationInfo"

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["userProductDeal"]?.[key] || fallback;

const UserProductDeal = props => {
    const { token } = isAuthenticated();

    const {
        laguangeElakay,
        infoSource,
        DealProduct,
        setProductaddToDeal,
        setShowSideDeal,
        showSideDeal,
        productsByArrival =[],
        loadProductsByArrival,
        loadM,
        loadM0,
        siseProduct,
        categoryID,
        filterCategory,
        text,
        size,
        skip,
        limit,
        titte= "Deal"
    }= props
    __setElakayInfoSource(infoSource);

    const loadProducts = (token, Deal, catID) => {
        loadProductsByArrival(token, Deal, catID )
    };
  const divCatProduct = useRef(null);
    const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };

    useEffect(() => {
        loadProducts(token, DealProduct, categoryID)
    }, [DealProduct, categoryID]);

    const loadMore = () => {
        scrollToParagraph(divCatProduct)
        loadM()
    };

    const loadMore0 = () => {
        scrollToParagraph(divCatProduct)
        loadM0()
    };


    const productALL = (
        <Row className="m-1" xs={2} sm={2} md={3} lg={4}>
            {
                productsByArrival?.map((product, i) => (
                    <div ref={divCatProduct}  className="col p-2" key={i}>
                        <Card
                            laguangeElakay={laguangeElakay}
                            infoSource ={infoSource}
                            loadProductsByArrival={loadProductsByArrival}
                            product={product}
                            showAddToCartButton={false}
                            showButtonUser={true}
                            setProductaddToDeal={setProductaddToDeal}
                            setShowSideDeal={setShowSideDeal}
                            showSideDeal={showSideDeal}
                            classCard0 = "col p-0"
                            DealProduct={DealProduct}
                            showShopV={false}
                            skip={skip}
                            limit={limit}
                        />
                </div>
                ))}

        </Row>
    )
    const resultPagination = (
        <div>
            {(skip - limit) + limit + 1} - {((skip + limit) > siseProduct) ? siseProduct : (skip + limit)}
             {/* of  */}
             {infoSource.language(infoSource, "label", "of")}
             {siseProduct}{__elakayText("t001", "items")}</div>
    )


    return (
 <div>
            
            {filterCategory()}
               <PaginationInfo
                    skip={skip}
                    limit={limit}
                    siseProduct={siseProduct}
                    infoSource={infoSource}
                    prodCat={titte}
                    />
            {productALL}
            < ButtonPagination
                laguangeElakay={laguangeElakay}
                infoSource ={infoSource}
                size={size}
                skip={skip}
                limit={limit}
                siseProduct={siseProduct}
                loadMore={loadMore}
                loadMore0={loadMore0}
            />
</div>
    )
      
};

export default UserProductDeal;